import {
  LocationHistory_Read_Minimal,
  NullableLoadState,
  NullableLocationHistorySource,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class LocationHistoryMinimal {
  public static parse(proto: LocationHistory_Read_Minimal): LocationHistoryMinimal {
    return new LocationHistoryMinimal(
      proto.id,
      proto.lat,
      proto.lon,
      dayjs(proto.occurred_at),
      proto.job_id,
      proto.load_id,
      proto.load_state,
      proto.source,
      proto.speed_meters_per_second,
      proto.offline_mode,
      proto.user_idle === true,
      proto.user_idle ?? null,
      proto.accuracy,
    );
  }

  public get id() {
    return this._id;
  }

  public get lat() {
    return this._lat;
  }

  public get lon() {
    return this._lon;
  }

  public get occurredAt() {
    return this._occurred_at;
  }

  public get jobId() {
    return this._job_id;
  }

  public get loadId() {
    return this._load_id;
  }

  public get loadState() {
    return this._load_state;
  }

  public get source() {
    return this._source;
  }

  public get speed() {
    return this._speed_meters_per_second;
  }

  public get offlineMode() {
    return this._offline_mode;
  }

  public get idle() {
    return this._idle;
  }

  // Null-preserving view of the raw `user_idle` field. The existing `idle`
  // getter coerces null -> false; consumers that must distinguish "moving"
  // from "no idle signal" (e.g. Truck Replay's Unknown bucket) read this.
  public get userIdleRaw() {
    return this._user_idle_raw;
  }

  public get accuracy() {
    return this._accuracy;
  }

  constructor(
    private _id: string,
    private _lat: string,
    private _lon: string,
    private _occurred_at: Dayjs,
    private _job_id: string | null,
    private _load_id: string | null,
    private _load_state: NullableLoadState,
    private _source: NullableLocationHistorySource,
    private _speed_meters_per_second: string | null,
    private _offline_mode: boolean,
    private _idle: boolean,
    private _user_idle_raw: boolean | null,
    private _accuracy: string | null,
  ) {}
}
